/** Unified brand placeholders — bclean hardcoded static image policy */

export const CHEEPSWEEPZ_LUXURY_PLACEHOLDER =
  'https://storage.digitalhustlerscaribbean.com/assets/cheepsweepz-luxury-placeholder.png';
export const CHEEPSWEEPZ_LUXURY_PLACEHOLDER_LOCAL = '/assets/cheepsweepz-luxury-placeholder.svg';
export const CARIBNAVI_LUXURY_PLACEHOLDER = '/assets/caribnavi-luxury-placeholder.svg';
export const DHC_BRAND_FALLBACK = 'https://digitalhustlerscaribbean.com/brand/dhc-badge.svg';

export function resolveBrandPlaceholder(site = 'navi') {
  if (site === 'cheepsweepz' || site === 'cheep') {
    return CHEEPSWEEPZ_LUXURY_PLACEHOLDER;
  }
  return CARIBNAVI_LUXURY_PLACEHOLDER;
}

export function resolveBrandPlaceholderFallback(site = 'navi') {
  if (site === 'cheepsweepz' || site === 'cheep') {
    return CHEEPSWEEPZ_LUXURY_PLACEHOLDER_LOCAL;
  }
  return CARIBNAVI_LUXURY_PLACEHOLDER;
}
